import './RoutePages.css';
import React from "react";
import darkConcrete from "../../assets/images/darkConcrete.jpg";
import logo from "../../assets/images/logo.png";
import missionPageAccent from '../../assets/images/missionPageAccent.svg'
import Footer from '../Footer.js';

function Mission() {

    return (
        <div className="routePageBackground">
            <div className="routePageBody routePageBodyMission">
                <div className="routePageHeader">
                    <img className="routePageLogoImage" src={logo} alt="cerise logo - interlocking black C's converging in the center into a round, pink dot" />
                    <h1 className="routePageHeaderText">MISSION </h1>
                </div>
                <img className="darkConcreteRoutePage darkConcreteRoutePageMission" src={darkConcrete} alt="dark grey wall of concrete" />
                <div className="routePageTextBlock routePageTextBlockFullWidth">
                    <img className="missionPageAccent" src={missionPageAccent} alt="black thin circles going around the text" />
                    <h3 className="missionHeaderText"> At Cerise Technology, we develop applications for web, mobile, and desktop. We’re driven by our vision of a smarter, more connected future, with efficiency, inclusivity, and sustainability as some of our core values. </h3>
                </div>
                <div className="routePageTextBlock routePageTextBlockMissionWidth">
                    <p className="missionBodyPillarHeader"> In a world where digital tools shape how we live, work, and connect, we are committed to building mobile and web applications that prioritize meaningful impact over profit. The immense power of modern technology should serve humanity, not exploit it. Too often, major tech companies prioritize monetization over the well-being of their users. </p>
                    <p className="missionBodyPillarHeader">   At Cerise, we take a path rooted in accountability, transparency, and long-term responsibility. Our mission is to create tools that empower people, foster community, and help to build a more equitable, sustainable future.</p>
                    <p className="missionBodyPillarHeader"> Our work at Cerise is built on the foundation of our three core pillars, and we keep these in mind with everything that we do. </p>
                    <p className="missionBodyPillarHeader"> 1. Efficiency and Optimization</p>
                    {/* <p className="missionBodyPillarText">Inefficient processes</p> */}
                    <p className="missionBodyPillarHeader"> 2. Inclusivity and Social Connection</p>
                    <p className="missionBodyPillarHeader"> 3. Environmental Sustainability </p>
                </div>
                            <Footer />

            </div>
            <a className="backToHomeTerms" href='/' rel="noreferrer"> back to home</a>
        </div>
    )
}

export default Mission;